export const FETCH_JOURNEYS_START = 'fetch_journeys_start';
export const FETCH_JOURNEYS_SUCCESS = 'fetch_journeys_success';
export const FETCH_JOURNEYS_FAILED = 'fetch_journeys_failed';

export const FETCH_IN_PROGRESS_JOURNEYS_START = 'fetch_in_progress_journeys_start';
export const FETCH_IN_PROGRESS_JOURNEYS_SUCCESS = 'fetch_in_progress_journeys_success';
export const FETCH_IN_PROGRESS_JOURNEYS_FAILED = 'fetch_in_progress_journeys_failed';

export const FETCH_COMPLETED_JOURNEYS_START = 'fetch_completed_journeys_start';
export const FETCH_COMPLETED_JOURNEYS_SUCCESS = 'fetch_completed_journeys_success';
export const FETCH_COMPLETED_JOURNEYS_FAILED = 'fetch_completed_journeys_failed';

export const FETCH_SPECIFIC_JOURNEY_START = 'fetch_specific_journey_start';
export const FETCH_SPECIFIC_JOURNEY_SUCCESS = 'fetch_specific_journey_success';
export const FETCH_SPECIFIC_JOURNEY_FAILED = 'fetch_specific_journey_failed';

export const FETCH_JOURNEY_USER_PROGRESS_START = 'fetch_journey_user_progress_start';
export const FETCH_JOURNEY_USER_PROGRESS_SUCCESS = 'fetch_journey_user_progress_success';
export const FETCH_JOURNEY_USER_PROGRESS_FAILED = 'fetch_journey_user_progress_failed';

export const PATCH_USER_PROGRESS = 'patch_user_progress';
